import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import { HighlightedProductsHeaderConfig } from 'pricing-pages-ui/constants/merchCards/HighlightedProductsHeaderConfig';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-ui/selectors/LoadingStateSelectors';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { ownsCrmSuiteProductLevel } from '../../selectors/ProductInventorySelectors';
import CurrentPlanTag from '../common/CurrentPlanTag';
import { SectionTitle } from '../common/SharedComponents';
import SuiteBusinessObjectives from './business-objectives/SuiteBusinessObjectives';
import { FillerRow, Section, MerchCardWrapper } from './MerchCardSharedComponents';
import HighlightedFreePriceDisplay from './price-display/HighlightedFreePriceDisplay';

const HighlightedFreeCard = ({
  productLine,
  commonStyles,
  perMonth
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel: FREE
  })); // In order for the grid to work, the wrapper element requires display: contents.
  // Children of the display grid item must get the grid-start attributes directly

  return /*#__PURE__*/_jsxs(MerchCardWrapper, {
    children: [/*#__PURE__*/_jsxs(Section, {
      className: "p-top-8",
      style: Object.assign({
        position: 'relative',
        gridRowStart: 1
      }, commonStyles),
      children: [isCurrentPlanLevel && /*#__PURE__*/_jsx(CurrentPlanTag, {}), /*#__PURE__*/_jsx(SectionTitle, {
        className: "m-all-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.freeCard.title"
        })
      })]
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-top-6",
      style: Object.assign({
        gridRowStart: 2
      }, commonStyles),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: productLine === 'crm' ? 'merchCards.freeCard.description.crm' : HighlightedProductsHeaderConfig[productLine][FREE].subtitle
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-top-4",
      style: Object.assign({
        gridRowStart: 3
      }, commonStyles),
      children: /*#__PURE__*/_jsx(HighlightedFreePriceDisplay, {
        perMonth: perMonth
      })
    }), /*#__PURE__*/_jsx(FillerRow, {
      row: 4,
      commonStyles: commonStyles
    }), /*#__PURE__*/_jsx(FillerRow, {
      row: 5,
      commonStyles: commonStyles
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-top-4",
      style: Object.assign({
        gridRowStart: 6
      }, commonStyles),
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [47],
        children: /*#__PURE__*/_jsx(SignupButton, {
          sourceId: "pricing-hero",
          productLine: productLine,
          use: "primary",
          style: {
            width: '100%',
            lineHeight: '23px'
          },
          nonMerchandiseIdProduct: 'crm'
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-bottom-6 flex flex-column align-center",
      style: Object.assign({}, commonStyles, {
        gridRowStart: 7
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-top-8",
      style: Object.assign({
        gridRowStart: 8
      }, commonStyles),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.businessObjectives.includes"
      })
    }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !hasPricingAndPurchasingSucceeded,
      heights: [47],
      children: /*#__PURE__*/_jsx(SuiteBusinessObjectives, {
        productLevel: FREE,
        commonStyles: commonStyles
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-bottom-6 p-top-3",
      style: Object.assign({
        gridRowStart: 10
      }, commonStyles)
    })]
  });
};

export default HighlightedFreeCard;